export default __webpack_public_path__ + "static/media/Logo.a873a069.svg";